module.exports = function($scope)
{
  var vm = this;
  vm.fileName = '';
  vm.comment = '';

  function init() {
    var canEdit = true;

    if($scope.ngDialogData){
      vm.fileName = $scope.ngDialogData.fileName.replace(/[^a-z0-9.]/gi, '_').toLowerCase();
      if($scope.ngDialogData.editFilename != null && typeof $scope.ngDialogData.editFilename != 'undefined'){
        canEdit = $scope.ngDialogData.editFilename;
      }
    }

    vm.allowFileNameChange = canEdit;
  }


  vm.onblurred = function(){
    vm.fileName = vm.fileName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
  }
  
  $scope.save = function () {
    $scope.closeThisDialog({action:"save", fileDetails: {fileName: vm.fileName, comment: vm.comment}})
  }

  init();
}
